import * as React from "react";
import { Icon } from "../../reusables/Icon";
import phoneImg from "../../images/phone-1.jpeg";
import emailImg from "../../images/email_address_zoho.svg";
import emails from "../../images/emails.svg";

const InfoItem = ({ name, value, iconName, children }) => {
  return (
    <div className="flex">
      <div className="flex items-center mr-3">
        <Icon name={iconName} className="h-7 w-7 text-primary" />
      </div>
      <div className=" flex flex-col">
        <span className="text-lg font-medium mb-3">{name}</span>
        {children}
        {/* <div className="relative">{children}</div> */}
      </div>
    </div>
  );
};

export const ContactInfo = () => {
  return (
    <div
      // style={{ backgroundImage: `url(${emails})` }}
      className="relative flex flex-col mx-6 mb-6 mt-12 items-center lg:m-10 lg:basis-5/12 lg:bg-contain lg:bg-no-repeat"
    >
      <div className="space-y-7">
        <div className="flex w-full justify-center mb-7">
          <span className="text-2xl font-bold ">Our Contact Details</span>
        </div>
        {/* <InfoItem name="telephone number" iconName="PhoneIcon">
          <img
            // className="absolute top-1 right-1.5"
            style={{ width: 110 }}
            alt="Phone number"
            src={phoneImg}
          />
        </InfoItem> */}
        <InfoItem name="email address" iconName="AtSymbolIcon">
          <img
            // className="absolute top-1 right-1.5"
            style={{ width: 214 }}
            alt="Email address"
            src={emailImg}
          />
        </InfoItem>
        <InfoItem name="our location" iconName="LocationMarkerIcon">
          <span>Springfield, VA, USA</span>
        </InfoItem>
      </div>
      <img className="hidden top-0 left-0 lg:block" src={emails} alt="emails" />
    </div>
  );
};

//
// dept of taxation   reg bus licence 703 222 8234
